import React, { useState } from "react";

export default function GoogleReviews({ reviews = [] }) {
  if (!reviews || reviews.length === 0) return null;

  const [currentIndex, setCurrentIndex] = useState(0);

  const allReviewsLink =
    "https://www.google.com/search?sca_esv=8a2b3961d0fe4bf2&sxsrf=ANbL-n6Bx_r2tHZ4jcjUMMnv42oFGrZe9A:1774907024017&q=Caspers+Tr%C3%A6service+Anmeldelser&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxI2MTIxNDQxMzM2sjQxNTczMjI138DI-IpR3jmxuCC1qFghpOjwsuLUorLM5FQFx7zc1JyU1BwgfxErIRUAxBuLyF4AAAA&rldimm=4241146632945762257&tbm=lcl&hl=da-DK&sa=X&ved=2ahUKEwiM6LP1y8iTAxU-4AIHHcdIPNMQ9fQKegQIVhAG&biw=2560&bih=1271";

  const total = reviews.length;
  const review1 = reviews[currentIndex % total];
  const review2 = total > 1 ? reviews[(currentIndex + 1) % total] : null;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };

  return (
    <section className="py-20 sm:py-24 lg:py-28 bg-[#12281D] text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 xl:gap-16 items-start">
          {/* Small left-aligned label column */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2.5">
              <span
                className="w-2.5 h-2.5 rounded-full bg-[#E67E33] shrink-0"
                aria-hidden="true"
              />
              <span className="text-xs sm:text-sm font-semibold tracking-wider uppercase text-[#8DB59E]">
                Kundeanmeldelser
              </span>
            </div>

            <div className="mt-3 sm:mt-4">
              <a
                href={allReviewsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs font-medium text-[#8DB59E]/80 hover:text-white transition-colors group"
              >
                <span>5,0 ★ på Google</span>
                <i
                  className="fa-solid fa-arrow-up-right-from-square text-[10px] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>

          {/* Main content area: two equal-width testimonial columns */}
          <div className="lg:col-span-9 grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-12 xl:gap-16 items-start">
            {/* First testimonial block */}
            <div className="flex flex-col justify-between min-h-full">
              <div className="space-y-6 sm:space-y-8">
                <blockquote className="text-lg sm:text-xl lg:text-2xl font-normal sm:font-medium text-white leading-relaxed tracking-tight">
                  "{review1.text}"
                </blockquote>

                <div>
                  <div className="text-base sm:text-lg font-semibold text-white tracking-tight">
                    {review1.author}
                  </div>
                  <div className="text-xs sm:text-sm text-[#8DB59E] mt-1 font-normal flex items-center gap-2">
                    <span>{review1.rating || "Google-anmeldelse"}</span>
                    {review1.google_link && (
                      <a
                        href={review1.google_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Se anmeldelse fra ${review1.author} på Google`}
                        className="text-[#8DB59E] hover:text-[#E67E33] transition-colors"
                      >
                        <i
                          className="fa-solid fa-arrow-up-right-from-square text-[11px]"
                          aria-hidden="true"
                        />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* Circular navigation buttons below the first testimonial block */}
              {total > 1 && (
                <div className="flex items-center gap-3 pt-8 sm:pt-10">
                  <button
                    type="button"
                    onClick={handlePrev}
                    aria-label="Forrige anmeldelse"
                    className="w-11 h-11 sm:w-12 sm:h-12 rounded-full border border-white/15 bg-white/5 hover:bg-white/10 hover:border-white/30 text-white flex items-center justify-center transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#E67E33]"
                  >
                    <i className="fa-solid fa-arrow-left text-sm" aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    onClick={handleNext}
                    aria-label="Næste anmeldelse"
                    className="w-11 h-11 sm:w-12 sm:h-12 rounded-full border border-white/15 bg-white/5 hover:bg-white/10 hover:border-white/30 text-white flex items-center justify-center transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#E67E33]"
                  >
                    <i className="fa-solid fa-arrow-right text-sm" aria-hidden="true" />
                  </button>
                </div>
              )}
            </div>

            {/* Second testimonial block */}
            {review2 && (
              <div className="flex flex-col justify-between min-h-full">
                <div className="space-y-6 sm:space-y-8">
                  <blockquote className="text-lg sm:text-xl lg:text-2xl font-normal sm:font-medium text-white leading-relaxed tracking-tight">
                    "{review2.text}"
                  </blockquote>

                  <div>
                    <div className="text-base sm:text-lg font-semibold text-white tracking-tight">
                      {review2.author}
                    </div>
                    <div className="text-xs sm:text-sm text-[#8DB59E] mt-1 font-normal flex items-center gap-2">
                      <span>{review2.rating || "Google-anmeldelse"}</span>
                      {review2.google_link && (
                        <a
                          href={review2.google_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`Se anmeldelse fra ${review2.author} på Google`}
                          className="text-[#8DB59E] hover:text-[#E67E33] transition-colors"
                        >
                          <i
                            className="fa-solid fa-arrow-up-right-from-square text-[11px]"
                            aria-hidden="true"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
